import React from "react";
import {ReactSVG} from "react-svg";
import "./MtplVehicleTypeButtonStyles.scss";

interface MTPLVehicleTypeButton {
    id?: string;
    title: string;
    image: string;
    altImage?: string;
    onClick: () => void;
}

export const MTPLVehicleTypeButton = ({onClick, altImage, image, title, id}: MTPLVehicleTypeButton) => {
    return (
        <div id={id} className={"vehicle-type-button"} onClick={onClick}>
            <div className={"vehicle-type-button__image_alt"}>
                <ReactSVG src={altImage}/>
            </div>

            <div className={"vehicle-type-button__image"}>
                <ReactSVG src={image}/>
            </div>
            <div className={"vehicle-type-button__title"}>
                <span>{title}</span>
            </div>
        </div>
    )
};